<script setup lang="ts">
import { storeToRefs } from 'pinia';
import useDataQuery from '../../../composables/useDataQuery';
import { getAllmaterials } from '../../../dataProviders/admin/materials';
import { useOrderStore } from '../../../stores/orderForm';
import { getSettings } from '../../../dataProviders/admin/settings';
import { calcOrderPrice } from '../../../utils/price';

const orderStore = useOrderStore();
const { order, adminView } = storeToRefs(orderStore);

const { data: dentalMaterials } = useDataQuery({ query: getAllmaterials, uniqueKey: 'formMaterials', placeholder: [], useCache: 'short' });
const { data: settigs } = useDataQuery({ query: getSettings, uniqueKey: 'settings', placeholder: { priceFullctr: 0, priceCoping: 0, price3D: 0, priceModels: 0 } });
const currentMaterialInfo = computed(() => dentalMaterials.value?.find(material => material.id === order.value.material_id));

const autoPrice = computed(() => {
  return calcOrderPrice(order.value, dentalMaterials.value, settigs.value);
});
</script>

<template>
  <Fieldset v-if="adminView" :pt="{ legend: 'bg-gray-200 border border-gray-300 hover:bg-gray-300' }">
    <template #legend>
      <div class="align-items-center flex gap-2 px-2">
        <span class="font-bold">Администрация</span>
        <i class="pi pi-cog !leading-[unset]" />
      </div>
    </template>

    <div class="mb-6 pd-form-cols-2">
      <FormItem
        field="price"
        :label="$t('orderForm.status.label')"
        required
      >
        <StatusSelect v-model="order.status" />
      </FormItem>

      <FormItem
        field="price"
        :label="$t('orderForm.price.label')"
        required
      >
        <NumberInput
          v-model="order.price"
          class="w-full"
          input-id="price"
          :min="0"
          :step="1"
          :pt="{ input: 'w-full' }"
          :max-fraction-digits="2"
        />
      </FormItem>

      <Message v-if="order.status === 'pending'" severity="info" class="md:col-span-2">
        Автоматично калкулирана цена: <b>{{ autoPrice }} €</b>
        <br>
        {{ order.number_parts }} (Брой) х
        <template v-if="currentMaterialInfo && order.machine_type === 'milling'">
          {{ currentMaterialInfo.price }} € (Материал)
        </template>
        <template v-if="order.machine_type === '3d'">
          {{ settigs?.price3D }} € (Материал 3D)
        </template>
        <template v-if="order.machine_type === 'models'">
          {{ settigs?.priceModels }} € (Материал Модели)
        </template>
        <template v-if="order.modeling">
          + {{ order.type === 'fullcontour' ? settigs?.priceFullctr : settigs?.priceCoping }} € (Моделиране)
        </template>
      </Message>
    </div>
  </Fieldset>
</template>
